import selectAll, { selectOne } from 'css-select';
import render from 'dom-serializer';
import type { Element, Node } from 'domhandler';
import { removeElement, replaceElement } from 'domutils';
import { parseDocument } from 'htmlparser2';

export function removeRichMediaWrapper(html: string): string {
	const document = parseDocument(html);
	const matchingElements = [
		...selectAll<Node, Element>('div[class=mce-img]', document),
		...selectAll<Node, Element>('div[class=mce-iframe]', document),
	];
	matchingElements.forEach((matchingElement) => {
		const childElement = selectOne('change-media', matchingElement);
		if (childElement) replaceElement(matchingElement, childElement);
		else removeElement(matchingElement);
	});
	return render(document);
}
